var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pnf d-flex align-center justify-center"},[_c('span',[_vm._v("페이지를 찾을 수 없어요 "),_c('span',[_vm._v("' ~ ^")])])])}
var staticRenderFns = []

export { render, staticRenderFns }